export default __webpack_public_path__ + "static/media/zones.d705ee4e.svg";